import { Link, useLoaderData } from 'react-router';
import { BackLink } from '@/components/back-link';
import { api } from '@/lib/api';
import { RowLink } from '@/components/row-link';
import { StyleForm } from './style-form';
import { LinksEditor, type BrandLink } from './links-editor';

type Style = { id: string; name: string; description: string | null; guidelines: string | null; system: boolean; templateCount: number; exampleCount: number };

export async function stylesLoader() {
  const [styles, globalLinks] = await Promise.all([api<Style[]>('/styles'), api<BrandLink[]>('/links?styleId=global')]);
  return { styles, globalLinks };
}

export function StylesPage() {
  const { styles, globalLinks } = useLoaderData<typeof stylesLoader>();
  return (
    <div className="space-y-5">
      <BackLink to="/templates">Templates</BackLink>
      <div>
        <h1 className="text-2xl">Style library</h1>
        <p className="text-sm text-muted-foreground">
          Each style has guidelines and its own example templates. Pick a style when generating and the AI follows that style's guidelines and examples.
        </p>
      </div>
      <div className="grid gap-5 lg:grid-cols-[1fr_380px]">
        <div className="overflow-x-auto rounded-lg border bg-white">
          <table className="data-table">
            <thead>
              <tr>
                <th>Style</th>
                <th>Templates</th>
                <th>AI examples</th>
              </tr>
            </thead>
            <tbody>
              {styles.map((s) => (
                <RowLink key={s.id} href={`/templates/styles/${s.id}`}>
                  <td>
                    <Link to={`/templates/styles/${s.id}`} className="ff-link font-medium">
                      {s.name}
                    </Link>
                    {s.system && <span className="ml-2 rounded bg-muted px-1.5 py-0.5 text-[10px] uppercase text-muted-foreground">default</span>}
                    {s.description && <div className="text-xs text-muted-foreground">{s.description}</div>}
                  </td>
                  <td>{s.templateCount}</td>
                  <td>{s.exampleCount === 0 ? <span className="text-amber-700">none yet</span> : s.exampleCount}</td>
                </RowLink>
              ))}
            </tbody>
          </table>
        </div>
        <StyleForm />
      </div>
      <LinksEditor links={globalLinks} styleId={null} title="Important links (all styles)" />
    </div>
  );
}
